import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  data: { username: string; password: string };
}

const initialState: InitialState = {
  data: { username: "", password: "" },
};

const loginFormSlice = createSlice({
  name: "loginFormSlice",
  initialState,
  reducers: {
    loginFormUpdate: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
  },
});

export const { loginFormUpdate } = loginFormSlice.actions;

export default loginFormSlice.reducer;
